import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IntencionPago, IntencionPagoEstado, IntencionPagoResponse } from '../models/intencion-pago';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root',
})

export class IntencionPagoService{
    private apiUrl = environment.apiUrl;

    constructor(
        private httpClient: HttpClient
    ){}
    
    crearIntencion(intencionPago: IntencionPago): Observable<IntencionPagoResponse> {

        const transactionId = uuidv4();
        const headers = new HttpHeaders()
        .set('X-Transaction-id', transactionId)
        .set('X-Fiid', '0029')
        .set('X-Comercio-Id', intencionPago.comercioId)
        .set('X-IBM-Client-Id', intencionPago.apiKey)
        .set('X-IBM-Client-secret', intencionPago.apiSecret);
         
        return this.httpClient.post<IntencionPagoResponse>(
            `${this.apiUrl}/intencion`, 
            intencionPago, { headers }
        );
    }


    consultarIntencion(intencionUuid: string, intencionPago: IntencionPago): Observable<IntencionPagoEstado>{
        
        const transactionId = uuidv4();
        const headers = new HttpHeaders()
        .set('X-Transaction-id', transactionId)
        .set('X-Fiid', '0029')
        .set('X-Comercio-Id', intencionPago.comercioId)
        .set('X-IBM-Client-Id', intencionPago.apiKey)
        .set('X-IBM-Client-secret', intencionPago.apiSecret);

        return this.httpClient.get<IntencionPagoEstado>(
            `${this.apiUrl}/intencion/${intencionUuid}`, 
             { headers }
        );
    }
}